function SkeletonBlock({ className = "" }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={`rounded-md bg-slate-200 motion-safe:animate-pulse ${className}`}
    />
  );
}

function FieldSkeleton({ wide = false }: { wide?: boolean }) {
  return (
    <div className={wide ? "sm:col-span-2" : ""} aria-hidden="true">
      <SkeletonBlock className="h-4 w-24" />
      <SkeletonBlock className="mt-2 h-11 w-full" />
    </div>
  );
}

export default function QaReportsLoadingSkeleton() {
  return (
    <section
      aria-busy="true"
      aria-label="Loading reports workspace"
      aria-live="polite"
      role="status"
      className="min-h-[22rem] space-y-5"
    >
      <SkeletonBlock className="h-6 w-48 max-w-full" />

      <div className="grid grid-cols-1 items-end gap-3 sm:grid-cols-2 lg:grid-cols-6">
        <FieldSkeleton />
        <FieldSkeleton wide />
        <SkeletonBlock className="h-11 w-full sm:w-32" />
      </div>

      <div
        aria-hidden="true"
        className="rounded-xl border border-subtle bg-accent-soft p-4"
      >
        <SkeletonBlock className="h-4 w-2/3 max-w-md" />
        <SkeletonBlock className="mt-3 h-3 w-full max-w-2xl" />
        <SkeletonBlock className="mt-2 h-3 w-4/5 max-w-xl" />
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, index) => (
          <FieldSkeleton key={index} />
        ))}
      </div>

      <span className="sr-only">
        Loading report types, dates, and report filters
      </span>
    </section>
  );
}
